import { api } from "@api/api";
import { DefaultPlan } from "@modules/defaultPlans/types";
import { DefaultPlanFormValues } from "@modules/defaultPlans/validations";

export async function editDefaultPlanService(id: string, data: Partial<DefaultPlanFormValues>): Promise<DefaultPlan> {
  const { data: defaultplan } = await api.patch<DefaultPlan>(`v1/default_plan_admin/${id}/`, data);

  return defaultplan;
}
